<template>
  <div class="test">
    {{ status }}
    <countDown
      v-show="status == '开始倒计时'"
      ref="countDown"
      :fire="fire"
      time="9"
      :tiping="tiping"
      :tipend="tipend"
      @onStatusChange="onStatusChange"
      @onEnd="onEnd"
    />
    <div v-show="status == '开始聚能'">
      <div class="playground">
        <div class="flame"></div>
        <div class="lighterBody">
          <div class="hover">hover me</div>
        </div>
        <div class="lid"></div>
      </div>
    </div>
  </div>
</template>

<script>
import countDown from "vue-canvas-countdown";
export default {
  components: {
    countDown,
  },
  name: "test",
  data() {
    return {
      websock: null,
      status: "正在连接主机",
      fire: 0,
      tiping: {
        text: "准备",
        color: "#fff",
      },
      tipend: {
        text: "开始聚能",
        color: "#fff",
      },
    };
  },
  created() {
    this.initWebSocket();
  },
  destroyed() {
    this.websock.close(); //离开路由之后断开websocket连接
  },
  methods: {
    onStatusChange(payload) {
      console.log("倒计时状态改变：", payload);
    },
    onEnd() {
      console.log("倒计时结束的回调函数");
    },
    initWebSocket() {
      //初始化weosocket
      const wsuri = "ws://112.74.66.49:3000";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      this.status = "已连接";
      this.websocketsend('{"code": 1,"message":"客户端登录"}');
      //this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      const redata = JSON.parse(e.data);
      switch (redata.code) {
        case "1":
          this.status = "连接成功";
          break;
        case "2":
          this.status = "开始倒计时";
          this.fire++;
          break;
        case "3":
          this.status = "开始聚能";
          break;
        case "4":
          this.status = "开始释放烟花";
          break;
        case "5":
          this.status = "连接成功";
          break;
        default:
          this.status = redata.message;
          break;
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      this.status = "断开连接";
      //关闭
      console.log("断开连接", e);
      this.initWebSocket();
    },
  },
};
</script>
<style lang='less'>
body {
  background: lighten(black, 80%);
}

:before,
:after {
  position: absolute;
  content: "";
}

.playground {
  // container
  position: relative;
  width: 140px;
  height: 400px;
  left: 50%;
  margin-left: -70px;
}

.flame {
  // flame
  opacity: 0;
  position: absolute;
  bottom: 60%;
  left: 42%;
  width: 14px;
  height: 70px;
  background-color: white;
  border-radius: 100% 100% 0 0;
  box-shadow: 0 0 20px #FFFEF0, 0 0 20px #FFFEE6, 0 0 20px #fefcc9,
    10px -10px 30px #feec85, -20px -20px 40px #ffae34, 20px -40px 50px #ec760c,
    -20px -60px 60px #cd4606, 0 -80px 70px #973716, 10px -90px 80px #451b0e;
  animation: flame 3s infinite linear;
}

.lighterBody {
  // body of the lighter
  position: absolute;
  width: 140px;
  height: 130px;
  top: 200px;
  left: 0;
  background: linear-gradient(
    to right,
    #959595 0%,
    #0d0d0d 46%,
    #010101 50%,
    #0a0a0a 53%,
    #4e4e4e 76%,
    #383838 87%,
    #1b1b1b 100%
  );
  border-radius: 2% 2% 8% 8%;
  box-shadow: inset 0 0 5px 5px lighten(black, 20%);

  &:before {
    // silver top part with a lot of holes
    width: 47px;
    height: 47px;
    top: -50px;
    left: 42px;
    border-radius: 6% 6% 0 0;
    background: linear-gradient(
      to right,
      #f5f6f6 0%,
      #dbdce2 21%,
      #b8bac6 49%,
      #dddfe3 80%,
      #f5f6f6 100%
    );
    content: " • • • • • • • • •";
    color: lighten(black, 90%);
    font-size: 20px;
    letter-spacing: 2px;
    line-height: 16px;
    text-shadow: 0 0 5px black;
    padding-top: 3px;
    padding-left: 4px;
  }

  &:after {
    // the lighter wheel
    width: 33px;
    height: 33px;
    background: radial-gradient(ellipse at center, #7d7e7d 0%, #0e0e0e 100%);
    border-radius: 100%;
    top: -33px;
    left: 6px;
    box-shadow: inset 0 0 1px 2px lighten(black, 50%);
  }
}

.playground:hover .flame {
  opacity: 1;
  transition: 0.4s linear;
}

.playground:hover .lid {
  animation: lidOff 0.3s linear;
  animation-fill-mode: forwards;
}

.hover {
  // hover text
  text-align: center;
  margin-top: 30%;
  font-family: "Sonsie One", cursive;
  font-size: 19px;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.8);

  &:before {
    // triangle for the lighter wheel
    z-index: 1;
    width: 0;
    height: 0;
    top: -50px;
    left: 20px;
    border-bottom: 35px solid lighten(black, 95%);
    border-left: 22px solid transparent;
  }
}

.lid {
  // the lighter lid
  z-index: 2;
  position: absolute;
  width: 140px;
  height: 75px;
  top: 125px;
  left: 0;
  background: linear-gradient(
    to right,
    #959595 0%,
    #0d0d0d 46%,
    #010101 50%,
    #0a0a0a 53%,
    #4e4e4e 76%,
    #383838 87%,
    #1b1b1b 100%
  );
  border-radius: 8% 8% 2% 2%;
  box-shadow: inset 0 0 5px 5px lighten(black, 20%);

  &:before {
    // the lighter fixation
    width: 10px;
    height: 10px;
    top: 70px;
    left: 133px;
    background: radial-gradient(
      ellipse at center,
      #959595 0%,
      #0d0d0d 46%,
      #010101 50%,
      #0a0a0a 53%,
      #4e4e4e 76%,
      #383838 87%,
      #1b1b1b 100%
    );
    border-radius: 100%;
  }
}

@keyframes flame {
  // flame animation
  0% {
    height: 70px;
    transform: skewY(0deg);
    border-radius: 100% 100% 0 0;
  }

  25% {
    height: 60px;
    transform: skewY(40deg);
    border-radius: 10% 100% 0 0;
  }

  60% {
    height: 65px;
    transform: skewY(-20deg);
    border-radius: 90% 10% 0 0;
  }
  70% {
    height: 50px;
    transform: skewY(10deg);
    border-radius: 10% 100% 0 0;
  }
  100% {
    height: 70px;
    transform: skewY(0deg);
  }
}

@keyframes lidOff {
  // moving the lid off animation
  from {
    transform: rotate(0deg);
    transform-origin: 100% 100%;
  }
  to {
    transform: rotate(130deg);
    transform-origin: 100% 100%;
  }
}
</style>
